/**
 * EIP-1271 constants
 *
 * @see https://eips.ethereum.org/EIPS/eip-1271
 */

/**
 * Magic value returned by isValidSignature for valid signatures
 * bytes4(keccak256("isValidSignature(bytes32,bytes)"))
 */
export const EIP1271_MAGIC_VALUE = "0x1626ba7e";

/**
 * Function selector for isValidSignature(bytes32,bytes)
 */
export const IS_VALID_SIGNATURE_SELECTOR = "0x1626ba7e";
